import PageConfigProvider from 'src/common/page/PageConfigProvider';
import useGetListParams from './helper/useGetListParams';
import { initFields } from './constants/initFields';
import ViewFilterTable from './ViewFilterTable';
import APIs from 'src/api';

const ClientCreditAllocation = () => {
  const { getListParams } = useGetListParams();
  return (
    <PageConfigProvider
      translatePrefix={'clientCreditAllocation'}
      initFields={initFields}
      getListParams={getListParams}
      getTableDataApiFunc={APIs.clientManagement.creditAllocation.getAll}
    >
      <ViewFilterTable />
    </PageConfigProvider>
  );
};
export default ClientCreditAllocation;
